import {
  DUITNOW_ID_ERRORS,
  type DuitNowIdType
} from '../constants/duitnow.const';

/** Client-side mirror of the backend check (backend is authoritative). Returns error copy or null. */
export function validateDuitNowId(
  type: DuitNowIdType,
  value: string
): string | null {
  const v = (value ?? '').trim();
  if (type === '05')
    return v.replace(/\D/g, '').length >= 7 ? null : DUITNOW_ID_ERRORS[type];
  if (type === '01')
    return /^\d{12}$/.test(v.replace(/-/g, ''))
      ? null
      : DUITNOW_ID_ERRORS[type];
  return /^[A-Za-z0-9]{5,20}$/.test(v.replace(/\s/g, ''))
    ? null
    : DUITNOW_ID_ERRORS[type];
}

export const maskDuitNowId = (value: string): string =>
  value.length <= 4 ? value : `••••${value.slice(-4)}`;
